import { render, staticRenderFns } from "./register-companyPacket.vue?vue&type=template&id=7b2ead9e"
import script from "./register-companyPacket.vue?vue&type=script&lang=js"
export * from "./register-companyPacket.vue?vue&type=script&lang=js"
import style0 from "./register-companyPacket.vue?vue&type=style&index=0&id=7b2ead9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports